import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { Cell } from './Cell';

const Ancestors = styled.span`
  flex-basis: max-content;
  flex-shrink: 99999;
  min-width: 1rem;
  padding-right: ${spacing.quarter};
  padding-left: ${spacing.quarter};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  background-color: ${colors.grey10};
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: ${spacing.eighth};
`;

const Name = styled.span`
  flex-basis: max-content;
  flex-shrink: 1;
  flex-grow: 1;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

type FieldNameCellProps = {
  ancestor: string;
  name: string;
};

export const FieldNameCell = ({ ancestor, name }: FieldNameCellProps) => (
  <Cell>
    {ancestor && <Ancestors>{ancestor}</Ancestors>}
    {name && <Name>{name}</Name>}
  </Cell>
);
